import React from 'react';
import { ShimmerThumbnail, ShimmerCircularImage, ShimmerTitle } from "react-shimmer-effects";

const DailyDiaryLoader = () => {
  return (
    <>
      <div className='mg-b-15 pd-b-15 border-bottom border-gray-200 mx-n-20 pd-x-20'>
        <div className="d-flex align-items-center">
          <ShimmerCircularImage size={30} className="flex-1 mg-b-0" />
          <div style={{ width: '87px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0 d-block" /></div>
        </div>
        <div className="d-flex align-items-center mg-t-15">
          <ShimmerCircularImage size={30} className="flex-1 mg-b-0" />
          <div style={{ width: '140px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0 d-block" /></div>
        </div>
        <div className="d-flex mg-t-15">
          <div className='flex-1'><div style={{ width: '130px' }}><ShimmerTitle line={2} gap={5} variant="primary" className="mg-b-0 d-block" /></div></div>
          <div style={{ width: '70px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0 d-block" /></div>
        </div>
        <div className="d-flex mg-t-15 pd-t-15 border-top border-top-dashed border-gray-200">
          <div className='flex-1'><div className='' style={{ width: '130px' }}><ShimmerTitle line={2} gap={5} variant="primary" className="mg-b-0 d-block" /></div></div>
          <div style={{ width: '70px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0 d-block" /></div>
        </div>
        <div className="d-flex mg-t-15 pd-t-15 border-top border-top-dashed border-gray-200">
          <div className='flex-1'><div className='' style={{ width: '130px' }}><ShimmerTitle line={2} gap={5} variant="primary" className="mg-b-0 d-block" /></div></div>
          <div style={{ width: '70px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0 d-block" /></div>
        </div>
      </div>
      <div className='mg-b-15 pd-b-15 border-bottom border-gray-200 mx-n-20 pd-x-20'>
        <div className='d-flex align-items-center'>
          <div className="d-flex align-items-center flex-1">
            <ShimmerCircularImage size={30} className="flex-1 mg-b-0" />
            <div style={{ width: '140px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0 d-block" /></div>
          </div>
          <div style={{ width: '50px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
        </div>
        <div className='d-flex align-items-center mg-t-15'>
          <div className='flex-1'><div style={{ width: '140px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div></div>
          <div style={{ width: '70px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
        </div>
        <div className='mg-t-15 pd-t-15 border-top border-top-dashed border-gray-200'>
          <div className='d-flex align-items-center'>
            <div className='flex-1'><div style={{ width: '140px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div></div>
            <div style={{ width: '50px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
          </div>
          <div style={{ width: '180px' }} className='mg-t-15'><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
        </div>
      </div>
      <div className='mg-b-15 pd-b-15 border-bottom border-gray-200 mx-n-20 pd-x-20'>
        <div className="d-flex align-items-center flex-1">
          <ShimmerCircularImage size={30} className="flex-1 mg-b-0" />
          <div style={{ width: '85px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0 d-block" /></div>
        </div>
        <div style={{ width: '76px' }} className='mg-t-15'><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
        <div className='d-flex align-items-center mg-t-8'>
          <div style={{ width: '110px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
          <div style={{ width: '110px' }} className='mg-l-20'><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
        </div>
        <div className='mg-t-15 pd-t-15 border-top border-top-dashed border-gray-200'>
          <div style={{ width: '76px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
          <div style={{ width: '110px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block mg-t-8" /></div>
        </div>
      </div>
      <div className='mg-b-15 pd-b-15 border-bottom border-gray-200 mx-n-20 pd-x-20'>
        <div className="d-flex align-items-center flex-1">
          <ShimmerCircularImage size={30} className="flex-1 mg-b-0" />
          <div style={{ width: '60px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0 d-block" /></div>
        </div>
        <div style={{ width: '76px' }} className='mg-t-15'><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
        <div className='mg-t-8 col-md-4'><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
      </div>
      <div className='mg-b-15 pd-b-15 border-bottom border-gray-200 mx-n-20 pd-x-20'>
        <div className="d-flex align-items-center flex-1">
          <ShimmerCircularImage size={30} className="flex-1 mg-b-0" />
          <div style={{ width: '126px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0 d-block" /></div>
        </div>
        <div className='mg-t-15'><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
      </div>
      <div>
        <div className="d-flex align-items-center flex-1">
          <ShimmerCircularImage size={30} className="flex-1 mg-b-0" />
          <div style={{ width: '126px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0 d-block" /></div>
        </div>
        <div className="mg-t-8 d-flex flex-wrap mx-n-4">
          <div className="pd-x-4 w-50"><ShimmerThumbnail height={178} className="rounded-3 mb-0" /></div>
          <div className="pd-x-4 w-50"><ShimmerThumbnail height={178} className="rounded-3 mb-0" /></div>
          <div className="pd-x-4 col-4"><ShimmerThumbnail height={114} className="rounded-3 mb-0" /></div>
          <div className="pd-x-4 col-4"><ShimmerThumbnail height={114} className="rounded-3 mb-0" /></div>
          <div className="pd-x-4 col-4"><ShimmerThumbnail height={114} className="rounded-3 mb-0" /></div>
        </div>
        <div className='mg-t-15'><ShimmerTitle line={2} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
      </div>
    </>
  );
};

export default DailyDiaryLoader;
